import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Button, Tabs,Tab, H4, H5, Dialog } from '@blueprintjs/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import { CsvBuilder } from "filefy";
import { CSVLink } from "react-csv";

import Chart from 'react-apexcharts';
import VocSpecPopup from './VocSpecPopup.js';
import { rounded } from '../../../utils.js'
import './VocByCorpus.css';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import { IconNames } from '@blueprintjs/icons';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants.js';
import { min } from 'lodash';

class VocByCorpus extends React.PureComponent {

  state = {
    isOpenModal:false,
    currentKey:"",    // the key to send to VocSpecPopup
    currentTab:'lemma',
    filterByCat: '',
   // selectedTabId:null
  }

  vocSpecPopupLemma = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'lemma'});
    this.toggleModal();
  }

  vocSpecPopupCat = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'cat'});
    this.toggleModal();
  }
  vocSpecPopupPattern = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'pattern'});
     this.toggleModal();
  }

  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  calcQuery = (entry,fea) => {
    fea=(!fea) ? "l":fea;
    if (entry.match(/^([^_]*)_(.*)/)) {
      return "<"+fea+"="+RegExp.$1+",c="+RegExp.$2+",#1>";
    } else if (entry.match(/ /)) {
      return entry.split(/ /).map( (t,i) => "<"+fea+"="+t+",#"+i.toString()+">").join("");
    } else {
      return "<"+fea+"="+entry+",#1>";
    }
  }
  
  renderFeatureStatKey = ( featureStatsKey, categs ) => {
    
    delete(categs["other"]);
    const labels = Object.keys(categs).sort();
    const series = Object.keys(categs).sort().map( categ => 
      categs[categ]
    ) 
    return (
      <div key={featureStatsKey} className="flex" style={{width:'500px'}}>
        <Chart 
          options={{
            chart: {
              type: 'pie',
              //width: 200
            },
            customScale: 1,
            labels: labels,
            title : {
              text:featureStatsKey,
              align:'center'
            }
            
          }}
          type={"pie"}
          series={series} 
          width={500} 
          title={{
            text:featureStatsKey
          }}
        />
      </div>
    );
  }
  handleSelectChange = (e) => {
    const { value } = e.target;
    this.setState({filterByCat:value});
  }

  // create three tables for diff stats. Used for tokens and for cats as well
  calcDiffTab = (tok2freq,ngram2freq,alignedPair2freq,v,t,name,session_id,fea) => {
    const sortedToks=Object.keys(tok2freq).sort((tok1,tok2)=>tok2freq[tok2]-tok2freq[tok1]);
    const sortedNgrams=Object.keys(ngram2freq).sort((ngram1,ngram2)=>ngram2freq[ngram2]-ngram2freq[ngram1]);
    const sortedAlignedPair=Object.keys(alignedPair2freq).sort((pair1,pair2)=>alignedPair2freq[pair2]-alignedPair2freq[pair1]);

    const dataTokTable=[];
    for (var i=0;i< sortedToks.length;i++){
      const row = {
        num:i+1,
        tok: sortedToks[i],
        freq: tok2freq[sortedToks[i]],
      };
      dataTokTable.push(row);
    }

    const dataNgramTable=[];
    for (i=0;i< sortedNgrams.length;i++){
      const row = {
        num:i+1,
        ngram: sortedNgrams[i],
        freq: ngram2freq[sortedNgrams[i]],
      };
      dataNgramTable.push(row);
    }

    const dataPairTable=[];
    for (i=0;i< sortedAlignedPair.length;i++){
      const row = {
        num:i+1,
        source: sortedAlignedPair[i].split(/\t/)[0],
        target: sortedAlignedPair[i].split(/\t/)[1],
        freq: alignedPair2freq[sortedAlignedPair[i]],
      };
      dataPairTable.push(row);
    }

    const tokCols=[
      { title: t('rank'), field:'num' },
      { title: t('addedOrModifiedToken').replace(/ /g, "\u00a0"),
        field: 'tok',
        render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.tok,fea)+"::!hasCorresp(#1)"})}}>{row.tok}</Button>,
        customFilterAndSearch: (term, rowData) => rowData.tok.match(term)
      },
      { title: t('frequency'), 
        field:'freq',
        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq,
      },
    ];

    const tokTable= 
      <MaterialTable
        title={t('unigrams')}        
        columns={tokCols}
        data={dataTokTable}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${name}_diffToks`,
          exportAllData: true,
          padding: 'dense',
          pageSize:100,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 100, 1000, dataTokTable.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
              className='straight'
            />
          ),
        }}
      />

    const ngramCols=[
      { title: t('rank'), field:'num' },
      { title: t('addedOrModifiedNgram').replace(/ /g, "\u00a0"),
        field: 'ngram',
        render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.ngram,fea)+"::!hasCorresp(#1)"})}}>{row.ngram}</Button>,
        customFilterAndSearch: (term, rowData) => rowData.ngram.match(term)
      },
      { title: t('frequency'), 
        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq,
        field:'freq' 
      },
    ];

    const ngramTable= 
      <MaterialTable
        title={t('ngrams')}        
        columns={ngramCols}
        data={dataNgramTable}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${name}_diffNgrams`,
          exportAllData: true,
          padding: 'dense',
          pageSize:100
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 100, 1000, dataNgramTable.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
              className='straight'
            />
          ),
        }}
      />

    const pairCols=[
      { title: t('rank'), field:'num' },
      { title: name,
        field: 'source',
        render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.source,fea)+"::!hasCorresp(#1)"})}}>{row.source}</Button>,
        customFilterAndSearch: (term, rowData) => rowData.source.match(term)
      },
      { title: v,
        field: 'target',
        render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.target,fea)+"::!hasCorresp(#1)"})}}>{row.target}</Button>,
        customFilterAndSearch: (term, rowData) => rowData.target.match(term)
      },

      { title: t('frequency'), 
        field:'freq',
        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq
      },
    ];

    const pairTable= 
      <MaterialTable
        title={t('alignedUnigrams')}        
        columns={pairCols}
        data={dataPairTable}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${name}_diffAlignedPairs`,
          exportAllData: true,
          padding: 'dense',
          pageSize:100,
  
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 100, 1000, dataPairTable.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
              className='straight'
            />
          ),
        }}
      />  
    return [tokTable,ngramTable,pairTable];
  }

  render() {
    const { 
        size, 
        vocSize,
        nbDocs,
        nbSents,
        nbToksDD,
        nbSentsDD,
        nbUtterancesDD,
        nbParas,
        nbCls,
        nbForms,
        averageLength,
        featureStats,
        repet4cat,
        dist4cat,
        lexicalDensity,
        lemmaStats, 
        catStats,
        cats,
        diffStats, 
        patternStats,
        name,
        displayLexicoStats,
        maxSpanSize,
        STTR,
        TTRSpanSize,
        useLemma4Repet, 
        t 
      } = this.props;
    const { isOpenModal} = this.state;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    // boolean to manage incomplete data
    const displayRepet4cat= false && displayLexicoStats  && (typeof repet4cat !=="undefined") && (repet4cat !== null);
    const displayFeatureStats= false && displayLexicoStats  && (typeof featureStats !=="undefined") && (featureStats !== null);
    const displayPatternStats= patternStats && patternStats.length>0 ;
    const displayDiffStats= diffStats && Object.keys(diffStats).length>0 ;

    const urlParams = new URLSearchParams(window.location.search);
    const session_id = urlParams.get('session_id');

    let propSentDD;
    let meanUtteranceLengthDD;
    if (nbSentsDD>0 && nbSents>0) {
      propSentDD=nbSentsDD/nbSents*100;
      
      if (nbUtterancesDD) {
        meanUtteranceLengthDD=nbSentsDD/nbUtterancesDD;
      }
    }
    let propTokDD;
    if (nbToksDD>0 && size>0) {
      propTokDD=nbToksDD/size*100;
    }
    

    let lemmaCols;
    let catCols;
    let patternCols;
    let dataLemmaTable = [];
    let dataCatTable = [];
    let dataPatternTable = [];

    let filterByCat=false;  // if true, display a select field to filter the table
 
    //  for subcorpus stats 
    if (lemmaStats[0] && lemmaStats[0].length>0 && lemmaStats[0][0].match(/_/)) {
      filterByCat=true;
    }
    var showOddRatio=false;
    // first case : fields include spec
    if (lemmaStats[0] && lemmaStats[0].length>=4) {
      for (var i=0;i<lemmaStats.length;i++) {
        const row = {
          num:i+1,
          lemma: lemmaStats[i][0],
          freq: lemmaStats[i][1],
          disp: lemmaStats[i][2],
          spec: lemmaStats[i][3],
        };
        if (lemmaStats[i][4]) {
          showOddRatio=true;
          row['oddRatio']=rounded(lemmaStats[i][4],2);
        }
        dataLemmaTable.push(row);
      }

      var specLabel=t('specificity');
      var dispLabel=t('totFreq');
      if (name==="global") {
        // if there is a specificity computation for global stats, this is done according to a ref corpus
        // to compute the terminologic weight
        specLabel=t('terminologicWeight');
        dispLabel=t('dispersion'); // dispersion only occur in global tab
      }
      lemmaCols=[
        { title: t('rank'), field:'num' },
        { title: t('lemma'), 
          render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.lemma)})}}>{row.lemma}</Button>,
          customFilterAndSearch: (term, rowData) => rowData.lemma.match(term),
          defaultFilter:this.state.filterByCat
        },
        { title: t('frequency'), field:'freq' },
        { title: dispLabel, field:'disp' },
        { title: specLabel, field:'spec'}
      ];
      if (showOddRatio) {
        lemmaCols.push(
          { title: t('oddRatio'), field:'oddRatio' }
        );
      }
      lemmaCols.push(
        { title: t('compare'), render: row => <button value={row.lemma} onClick={this.vocSpecPopupLemma}>cmp</button> },
      );

    } else {
      if (lemmaStats.length) {
        for (i=0;i<lemmaStats.length;i++) {
          const row = {
            num:i+1,
            lemma: lemmaStats[i][0],
            freq: lemmaStats[i][1],
            disp: lemmaStats[i][2],
          };
          dataLemmaTable.push(row);
        }

        // for global stats only
        lemmaCols=[
          { title: t('rank'), field:'num' },
          { title: t('lemma'), 
            render: row => <Button minimal small onClick={()=> {this.props.performSearch({query:this.calcQuery(row.lemma)})}}>{row.lemma}</Button>,
            customFilterAndSearch: (term, rowData) => rowData.lemma.match(term),
            defaultFilter:this.state.filterByCat
          },
          { title: t('frequency'), field:'freq' },
          { title: t('dispersion'), field:'disp' },
          { title: t('compare'), render: row => <button value={row.lemma} onClick={this.vocSpecPopupLemma}>cmp</button> },
        ];
      }
    }

    // catStats may be null (no specific cat)
    if (catStats) {
      if (catStats[0].length===4) {
        for (i=0;i<catStats.length;i++) {
          const row = {
            num:i+1,
            cat: catStats[i][0],
            freq: catStats[i][1],
            totFreq: catStats[i][2],
            spec: catStats[i][3],
          }
          dataCatTable.push(row);
        }
        catCols=[
          { title: t('rank'), field:'num' },
          { title: t('category'), field:'cat'  },
          { title: t('frequency'), field:'freq' },
          { title: t('totFreq'), field:'totFreq' },
          { title: t('specificity') , field:'spec'},
          { title: t('compare'), render: row => <button value={row.cat} onClick={this.vocSpecPopupCat}>cmp</button> },
        ];
      } else {
        for (i=0;i<catStats.length;i++) {
          const row = {
            num:i+1,
            cat: catStats[i][0],
            freq: catStats[i][1],
          };
          dataCatTable.push(row);
        }

        catCols=[
          { title: t('rank'), field:'num' },
          { title: t('category'), field:'cat' },
          { title: t('frequency'), field:'freq' },
          { title: t('compare'), render: row => <button value={row.cat} onClick={this.vocSpecPopupCat}>cmp</button> },
        ];
      }
    }

    // stats for patterns
    // for '__global__', we may have spec
    // console.log("Pattern",patternStats);
    if (displayPatternStats) {
      // tests if there is a spec column
      const specCol=(patternStats[0].length > 3);
      var displaySpec;
      var displayOddRatio;
      for (i=0;i<patternStats.length;i++) {
        //console.log("Pattern",patternStats[i][0]);
        const row = {
          num:i+1,
          pattern: patternStats[i][0],
          realization: patternStats[i][1],
          freq: patternStats[i][2],
        }
        if (specCol) {
          // spécificité exogène
          row['spec']=patternStats[i][3];
        } else if (this.props.spec["pattern"] && this.props.spec["pattern"][row.realization] && this.props.spec["pattern"][row.realization][this.props.name]) {
          // spécificité endogène
          row['spec']=this.props.spec["pattern"][row.realization][this.props.name];
          displaySpec=true;
        }
        if (patternStats[i][4]) {
          row['oddRatio']=rounded(patternStats[i][4],2);
          displayOddRatio=true
        }
        dataPatternTable.push(row);
      }

      patternCols=[
        { title: t('rank'), field:'num' },
        { title: t('pattern'), field:'pattern'},
        { title: t('realization'), 
          field:'realization',
          render: row => <Button minimal small onClick={()=> { this.props.performSearch({query:this.calcQuery(row.realization)})} } >{row.realization}</Button>,
      },
        { title: t('frequency'), field:'freq' },
      ];
      if (specCol || displaySpec) {
        patternCols.push({title: t('specificity'), field:'spec' });
        if (displayOddRatio) {
          patternCols.push({title: t('oddRatio'), field:'oddRatio' });
        }
        patternCols.push({ title: t('compare'), render: row => <button value={row.realization} onClick={this.vocSpecPopupPattern}>cmp</button> });        
      }
      
    }

    // stats for diff data (extracted from diff comparaison of versions)
    const diffTabs=[];
    if (diffStats) {
      for (let v in diffStats) {
          // token level
          var [tokTable,ngramTable,pairTable]=this.calcDiffTab(diffStats[v].tok2freq,diffStats[v].ngram2freq,diffStats[v].alignedPair2freq,v,t,name,session_id,"w");
          //console.log(diffStats[v].cat2freq);
          var [tokCatTable,ngramCatTable,pairCatTable]=this.calcDiffTab(diffStats[v].cat2freq,diffStats[v].ngramCat2freq,diffStats[v].alignedPairCat2freq,v,t,name,session_id,"c");

          const tabContent=(
            <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
              <Tab key={'tokens'+v} id={'tokens'+v} title={t('tokens')} panel={tokTable} />
              <Tab key={'ngrams'+v} id={'ngrams'+v} title={t('ngrams')} panel={ngramTable} />
              <Tab key={'pairs'+v} id={'pairs'+v} title={t('alignedPairs')} panel={pairTable} />
              <Tab key={'cats'+v} id={'cats'+v} title={t('posTags')} panel={tokCatTable} />
              <Tab key={'ngramCats'+v} id={'ngramCats'+v} title={t('posTagsNgrams')} panel={ngramCatTable} />
              <Tab key={'pairCats'+v} id={'pairCats'+v} title={t('posTagsAlignedPairs')} panel={pairCatTable} /> 
            </Tabs>
          );
          const thisTab= <Tab key={v} id={v} title={v} panel={tabContent} />

          diffTabs.push(thisTab)
      };
    }

    const diffTab=(
      <>
        <H4>{ t('statisticsForDiffComparisonBetweenVersions') }</H4>
        <p>{ t('formsThatAppearOnlyIn')+" "+name }</p>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          {diffTabs}
        </Tabs>
      </>
    );

    // console.log(this.props.freqCSV);

    const lemmaTable = (
      <>
        { this.props.freqCSV && this.props.freqCSV.length>0 && 
          <p>
            <CSVLink data={this.props.freqCSV} filename={'lemmaFreq.csv'}>{t('uploadCSV4lemmaFreq')}</CSVLink>
          </p>
        }
        { filterByCat && 
          <EnhancedSingleSelect
            label={t('filterByCat')}
            options={cats}
            name='filter'
            hasDefault={true}
            hasSelectableDefault={true}
            onChange={this.handleSelectChange}
            popoverProps={{ minimal: true }}
          />
        }
        <br/>
        <p>{name==='global' ? t('first5000MoreFrequent'): t('first5000MoreSpecific')}</p>
        <br/>
        <MaterialTable
          title={t('lemma')}        
          columns={lemmaCols}
          data={dataLemmaTable}
          options={{
            filtering: true,
            search: true,
            sorting: true,
            exportButton: true,
           //exportFileName:`${name}_lemma`,
            exportAllData: true,
            padding: 'dense',
            pageSize:min([100,dataLemmaTable.length]),
            exportCsv: (columns, data) => {
              const fileName = name+"_lemma";
              const builder = new CsvBuilder(
                  fileName + ".csv"
              );
              builder
                  .setColumns(
                      ["rang","lemme","freq","disp","spec"]
                  )
                  .setDelimeter(this.props.csvDelimiter).addRows(
                    data.map((rowData) =>
                        [
                          rowData.num,
                          rowData.lemma,
                          rowData.freq,
                          rowData.disp,
                          rowData.spec
                        ]
                      )
                  )
                  .exportFile();
            },
          }}
          components={{
            Pagination: paginationProps => (
              <TablePagination
                {...paginationProps}
                rowsPerPageOptions={[10, 100, 1000, dataLemmaTable.length]}
              />
            ),
            Container: props => (
              <Paper
                {...props}
                elevation={0}
                className='straight'
              />
            ),
          }}
        />
      </>  
    );

    const patternTable = (
      <>
        <MaterialTable
          title={t('patterns')}        
          columns={patternCols}
          data={dataPatternTable}
          options={{
            filtering: true,
            search: true,
            sorting: true,
            exportButton: true,
            exportFileName:`${name}_patterns`,
            exportAllData: true,
            padding: 'dense',
            pageSize:min([100,dataPatternTable.length]),
          }}
          components={{
            Pagination: paginationProps => (
              <TablePagination
                {...paginationProps}
                rowsPerPageOptions={[10, 100, 1000, dataPatternTable.length]}
              />
            ),
            Container: props => (
              <Paper
                {...props}
                elevation={0}
                className='straight'
              />
            ),
          }}
        />
      </>  
    );

    
    const catTable = (
        <MaterialTable
          title={t('category')}
          columns={catCols}
          data={dataCatTable}
          options={{
            filtering: true,
            search: true,
            sorting: true,
            exportButton: true,
            exportFileName:`${name}_pos`,
            exportAllData: true,
            pageSize:min([100,dataLemmaTable.length]),
            padding:'dense'
          }}
          components={{
            Pagination: paginationProps => (
              <TablePagination
                {...paginationProps}
                rowsPerPageOptions={[10, 100, 1000, dataCatTable.length]}
              />
            ),
            Container: props => (
              <Paper
                {...props}
                elevation={0}
                className='straight'
              />
            ),
          }}
        />
    );


    const repet4catBars=displayRepet4cat ? (
      <Chart
        options={{

          plotOptions: {
            bar: {
              columnWidth: '80%',
            }
          },
          dataLabels: {
            enabled: true,
          },
          xaxis: {
            type: 'text',
            categories: Object.keys(repet4cat).sort(),
            labels: {
              rotate: -90
            }
          }
        }}
        type="bar"
        width={300}
        series={[{ 
          name:t('repet4cat'),
          data: Object.keys(repet4cat).sort().map( cat=>repet4cat[cat] )
        }]}
      />
    ):"";

    const dist4catBars=dist4cat ? Object.keys(dist4cat).sort().map( cat=> 
      <div key={cat}>
        <Chart
          options={{

            plotOptions: {
              bar: {
                columnWidth: '80%',
                dataLabels: {
                  position:'top',
                }
              }
            },
            dataLabels: {
              enabled: false,
            },
            title: {
              text: cat,
            },
            xaxis: {
              type: 'text',
              categories: Object.keys(dist4cat[cat]).sort((a,b) => parseInt(a)-parseInt(b)).map( range => range * maxSpanSize / 20 ),
              labels: {
                rotate: -90
              }
            }
          }}
          type="bar"
          width={300}
          series={[{ 
            name:t('dist4cat'),
            data: Object.keys(dist4cat[cat]).sort((a,b) => parseInt(a)-parseInt(b)).map( range =>dist4cat[cat][range] )
          }]}
        />
      </div>
    ):"";

    return(
      <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
          { this.props.displayShortName &&
            <H5>{t('name')} : {this.props.name}</H5>
          }
          <Accordion defaultExpanded={true}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
            <H4>{t('globalStats')}</H4>
            </AccordionSummary>
            <AccordionDetails>
              <div style={{flex:'nonre'}}>
                <ul>
                  { nbDocs>0 &&
                   <li>{t('docNumberColon')} { Intl.NumberFormat(langFormat).format(nbDocs)}</li>
                  }
                  { nbParas>0 &&
                    <li>{t('paraNumberColon')} { Intl.NumberFormat(langFormat).format(nbParas)}</li>
                  }
                  { nbSents>0 &&
                    <li>{t('sentNumberColon')} { Intl.NumberFormat(langFormat).format(nbSents)}</li>
                  }
                  { nbCls>0 &&                    
                    <li>{t('clsNumberColon')} { Intl.NumberFormat(langFormat).format(nbCls)}</li>
                  }
                  { size>0 &&                    
                    <li>{t('tokenNumberColon')} { Intl.NumberFormat(langFormat).format(size)}</li>
                  }
                  { nbForms>0 &&                    
                    <li>{t('formNumberColon')} { Intl.NumberFormat(langFormat).format(nbForms)}</li>
                  }
 
                </ul>
                <H5>{t('vocStats')}</H5>
                <ul>
                  <li>{t('vocSizeColon')} { Intl.NumberFormat(langFormat).format(vocSize)}</li>
                  <li>{t('TTRColon')} { Intl.NumberFormat(langFormat).format(vocSize/size)}</li>
                  { (TTRSpanSize>0 && STTR>0) &&
                    <li>{"STTR ("+t('for')+" "+TTRSpanSize.toString()+") :"}  { Intl.NumberFormat(langFormat).format(STTR/TTRSpanSize)}</li>
                  }
                  { lexicalDensity>0 &&
                    <li>{t('lexicalDensityColon')} { Intl.NumberFormat(langFormat).format(lexicalDensity)}</li>
                  }
                </ul>
                { nbForms>0 &&
                  <>
                    <H5>{t('readability')}</H5>
                    <ul>
                      <li>{t('averageSentLengthFormsColon')} { Intl.NumberFormat(langFormat).format(rounded(nbForms/nbSents))}</li>
                      <li>{t('averageWordLengthColon')} { Intl.NumberFormat(langFormat).format(averageLength)}</li>
                    </ul>
                  </>
                }
                { propSentDD > 0 &&
                  <>
                    <H5>{t('directDiscourse')}</H5>
                    <ul>                             
                      <li>{t('nbToksDDColon')} { Intl.NumberFormat(langFormat).format(nbToksDD)}</li>
                      <li>{t('propTokDDColon')} { Intl.NumberFormat(langFormat).format(propTokDD)}%</li>
                      <li>{t('nbSentsDDColon')} { Intl.NumberFormat(langFormat).format(nbSentsDD)}</li>
                      <li>{t('nbUtterancesDDColon')} { Intl.NumberFormat(langFormat).format(nbUtterancesDD)}</li>
                      <li>{t('propSentDDColon')} { Intl.NumberFormat(langFormat).format(propSentDD)}%</li>
                      <li>{t('meanUtteranceLengthDDColon')} { Intl.NumberFormat(langFormat).format(meanUtteranceLengthDD)}</li>
                    </ul>
                  </>
                }
              </div>
              </AccordionDetails>
            </Accordion>  

          { (displayFeatureStats) &&
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <H4>{t('featureStats')}</H4>
              </AccordionSummary>
              <AccordionDetails>

                <div className="flex">
                  { Object.keys(featureStats).sort().map( featureStatsKey => this.renderFeatureStatKey(featureStatsKey,featureStats[featureStatsKey]))}
                </div>

              </AccordionDetails>
            </Accordion>   
          }
          { (displayRepet4cat) &&
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <H4>{t('repet4cat')}</H4>
              </AccordionSummary>
              <AccordionDetails>
                  
                  <div className="flex">
                    <div style={{width:'500px'}}>{ repet4catBars }{ dist4catBars }</div>
                    
                    <div >
                      <p>{t("repet4catExplanation")}</p>
                      <br/>
                      <p>{t("maxSpanSizeColon")} { maxSpanSize }</p>
                      <p>{t("useLemma4RepetColon")} { useLemma4Repet===1? t("lemma") : t("form") }</p>
                    </div>
                   
                  </div>
                  
              </AccordionDetails>
            </Accordion> 
          }
        </Paper>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          <Tab key='lemma' id='lemma' title={name==='global'? t('globalLemmata'):t('specificLemmata')} panel={lemmaTable} />
          <Tab key='cat' id='cat' title={name==='global'? t('globalPos'):t('specificPos')} panel={catTable} />
          { displayPatternStats &&
            <Tab key='patternStats' id='patternStats' title={t('patternStats')} panel={patternTable} />
          }          
          { displayDiffStats &&
            <Tab key='diffStats' id='diffStats' title={t('diffStats')} panel={diffTab} />
          }
        </Tabs>

        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('vocSpecComparison')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          <VocSpecPopup entry={this.state.currentKey} data={this.props.spec[this.state.currentTab][this.state.currentKey]}/>
        </Dialog>
        
      </>
    );
  }

}

VocByCorpus.propTypes = {
  name: PropTypes.string,
  displayShortName : PropTypes.bool,
  lemmaStats: PropTypes.array,
  freqCSV: PropTypes.array,
  catStats: PropTypes.array,
  patternStats : PropTypes.array,
  cats: PropTypes.array,
  size: PropTypes.number,
  vocSize: PropTypes.number,
  spec: PropTypes.object,
  featureStats: PropTypes.object,
  nbDocs: PropTypes.number,
  nbSents: PropTypes.number,
  nbToksDD: PropTypes.number,
  nbSentsDD: PropTypes.number,
  nbUtterancesDD: PropTypes.number,
  nbParas: PropTypes.number,
  nbCls: PropTypes.number,
  nbForms: PropTypes.number,
  lexicalDensity: PropTypes.number,
  averageLength: PropTypes.number,
  repet4cat: PropTypes.object,
  dist4cats: PropTypes.object,
  maxSpanSize: PropTypes.number,
  TTRSpanSize: PropTypes.number,
  STTR:PropTypes.number,
  useLemma4Repet : PropTypes.number,
  displayLexicoStats:  PropTypes.bool,
  diffStats: PropTypes.object,
  performSearch: PropTypes.func,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(VocByCorpus);
